// @vue/component
import {useAllGoalsStore} from "@/stores/WheelAnalysis/allGoals";
import {storeToRefs} from "pinia";
import {useChallengeStore} from "@/stores/WheelAnalysis/challenge";

export default {
  name: 'ReviewGoals',

  components: {},

  mixins: [],

  props: {},

  setup() {
    const allGoalsStore = useAllGoalsStore()
    const challengeStore = useChallengeStore()

    const { reviewNotes } =  storeToRefs(allGoalsStore)
    const { editMode } =  storeToRefs(challengeStore)

    return { reviewNotes, allGoalsStore, editMode }
  },


  computed: {},

  mounted () {
    this.allGoalsStore.fetchWheelAnalysis()
  },

  methods: {
    downloadNotes() {
      const blob = new Blob([this.reviewNotes || ""], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "SDG 360 Wheel Analysis Notes.txt";
      link.click();
      URL.revokeObjectURL(url);
    }
  }
}
